<template>
  <div
    class="counselor counselor__on-image lav-cards__card-wrapper"
    data-slider-item
    :class="{
      'show-city-label': cityLabel,
      'show-grid-label': showGridLabel,
    }"
  >
    <div class="lav-card__container">
      <figure class="lav-card__figure">
        <counselor-card-image
          :counselor="counselor"
          :is-therapist="isTherapist"
          :link="link"
        />
        <div class="lav-card__text-image">
          <p class="lav-card__name">
            <a :href="link" v-text="counselor.name" />
          </p>
          <p class="counselor-card__title" v-text="counselor.title" />
          <rating-stars
            class="counselor-card__rating"
            show-rating-text
            v-if="counselor.rating > 0"
            :link="link"
            :number-of-reviews="counselor.number_of_reviews"
            :rating="parseFloat(counselor.rating)"
          />
        </div>
      </figure>
      <span
        class="lav-card__grid-label"
        v-if="showGridLabel"
        v-text="gridLabelText"
      />
      <span
        class="lav-card__city-label"
        v-else-if="currentSite !== 'DK' && cityLabel && counselor.remote_user"
        v-text="texts.remoteLabel"
      />
      <span
        class="lav-card__city-label"
        v-else-if="cityLabel && !counselor.remote_user"
        v-text="cityLabel"
      />
      <div class="lav-card__text">
        <div class="lav-card__text-first">
          <counselor-archive-card-description
            :counselor="counselor"
            :link="link"
            :role="role"
          />
          <div class="counselor-card__competence" v-if="showCompetenceAreas">
            <competence-area-pills
              v-if="showCompetenceAreas"
              :competence-areas="competenceAreas"
              :filtered-competences="filteredCompetences"
            />
          </div>
          <p
            class="counselor-card__languages"
            v-if="isArchive && counselor.languages"
            v-html="languagesString"
          />
        </div>
        <div class="lav-card__text-second">
          <counselor-card-meeting-types
            v-if="isArchive"
            :counselor="counselor"
            :filtered-meeting-types="filteredMeetingTypes"
            :is-lawyer="isLawyer"
          />
          <counselor-card-cta
            :counselor="counselor"
            :is-lawyer="isLawyer"
            :is-therapist="isTherapist"
            :link="link"
            :show-phone-number="showPhoneNumber"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompetenceAreaPills from 'Main/components/CompetenceAreaPills.vue';
import CounselorCardImage from 'Main/components/counselor-card/components/CounselorCardImage.vue';
import CounselorCardMeetingTypes from 'Main/components/counselor-card/components/CounselorCardMeetingTypes.vue';
import CounselorCardCta from 'Main/components/counselor-card/components/cta/CounselorCardCta.vue';
import RatingStars from 'Main/components/RatingStars.vue';
import CounselorArchiveCardDescription from 'Main/counselor-grid/components/CounselorArchiveCardDescription.vue';
import BaseCounselorCard from '../BaseCounselorCard.vue';

export default {

  components: {
    CompetenceAreaPills,
    CounselorArchiveCardDescription,
    CounselorCardCta,
    CounselorCardImage,
    CounselorCardMeetingTypes,
    RatingStars,
  },

  computed: {

    gridLabelText() {
      return this.counselor.booked_in_the_latest_72_hours;
    },
    showGridLabel() {
      return (
        this.gridLabelText &&
        (this.isLawyer || this.isTherapist) &&
        !this.cityLabel
      );
    },
  },

  data() {
    return {
      counselorContactTexts: theme_vars.counselorContactFormTexts,
      currentSite: theme_vars.currentSite,
      currentSiteId: theme_vars.currentSiteId,
      texts: theme_vars.counselorSlider,
    };
  },

  extends: BaseCounselorCard,
  name: 'CounselorCardTextOnImage',

  props: {
    cityLabel: {
      default: '',
      type: String,
    },
    counselor: {
      required: true,
      type: Object,
    },
    isArchive: {
      default: false,
      type: Boolean,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    role: {
      default: '',
      type: String,
    },
    showCompetenceAreas: {
      default: false,
      type: Boolean,
    },
    showPhoneNumber: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
